import { ContentSubtype } from "./ContentSubtype";

export type MovieContentSubtype = typeof movieContentSubtypes[number];

export const movieContentSubtypes = [
    ContentSubtype.Movie,
    ContentSubtype.TvSingle,
    ContentSubtype.FeatureDocumentary,
    ContentSubtype.ShortFilm
] as const;

export const mapToMovieContentSubtype = (movieType: number): MovieContentSubtype => {
    if (!isMovieContentSubtype(movieType)) {
        throw new Error("Wrong movie content type");
    }

    return movieType;
};

export const isMovieContentSubtype = (contentType: number): contentType is MovieContentSubtype =>
    movieContentSubtypes.includes(contentType);

export const ensureMovieContentSubtype: (contentType: number) => asserts contentType is MovieContentSubtype = (
    contentType: MovieContentSubtype
) => {
    if (!movieContentSubtypes.includes(contentType)) {
        throw Error(`Content subtype should be movie'`);
    }
};
